import React from 'react';

const allowedTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span', 'div'];

const Typography = ({ variant = 'p', children, className = '' }) => {
  const Tag = allowedTags.includes(variant) ? variant : 'p';
  return <Tag className={`${variant} ${className} typog`}>{children}</Tag>;
};

export default Typography;

// import React from 'react';
// // import './typography.scss';

// const Typography = ({ variant, children, className = '' }) => {
//   return <p className={`${variant} ${className}`}>{children}</p>;
// };

// export default Typography;
